module.exports = __webpack_public_path__ + "static/Youth-Groups-f1fe91206628c804bb39d8aea24a0cc1.jpg";